var map = {
	"./avatar-1.png": 1427,
	"./avatar-10.png": 1428,
	"./avatar-11.png": 1429,
	"./avatar-12.png": 1430,
	"./avatar-2.png": 1431,
	"./avatar-3.png": 224,
	"./avatar-4.png": 1432,
	"./avatar-5.png": 1433,
	"./avatar-6.png": 1434,
	"./avatar-7.png": 1435,
	"./avatar-8.png": 1436,
	"./avatar-9.png": 1437,
	"./img-profile-bg.png": 1438,
	"./img-user.png": 890,
	"./profile.png": 1439,
	"./user-round.svg": 1440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 889;